import { Plus, X } from "lucide-react";

export default function PerksEditor({ id, perks, onChange }) {
  const set = (i, v) => onChange(perks.map((p, j) => (j === i ? v : p)));
  return (
    <div className="text-xs text-muted-foreground" data-testid={`plan-perks-${id}`}>
      Feature list
      <div className="mt-1 space-y-2">
        {perks.map((p, i) => (
          <div key={i} className="flex gap-2">
            <input value={p} maxLength={120} onChange={(e) => set(i, e.target.value)} data-testid={`plan-perk-${id}-${i}`}
              className="flex-1 min-w-0 min-h-[40px] px-3 bg-[#141414] border border-[#262626] text-base sm:text-sm text-white focus:outline-none focus:border-white" />
            <button onClick={() => onChange(perks.filter((_, j) => j !== i))} aria-label="Remove feature" data-testid={`plan-perk-remove-${id}-${i}`}
              className="w-10 shrink-0 border border-[#262626] hover:border-[#F87171] hover:text-[#F87171] flex items-center justify-center transition-colors">
              <X size={14} />
            </button>
          </div>
        ))}
      </div>
      {perks.length < 10 && (
        <button onClick={() => onChange([...perks, ""])} data-testid={`plan-perk-add-${id}`}
          className="mt-2 min-h-[36px] px-3 border border-dashed border-[#262626] hover:border-white text-white font-mono-label text-[10px] inline-flex items-center gap-1.5 transition-colors">
          <Plus size={12} /> Add feature
        </button>
      )}
    </div>
  );
}
